import Home from './Home'
import Menu from './Menu'
import OverviewMenu from './OverviewMenu'
import SidebarPage from './SidebarPage'
import SidebarSlideshow from './SidebarSlideshow'
import Slideshow from './Slideshow'
import InteractiveElement from './InteractiveElement'
import FullContentDisplay from './FullContentDisplay'
import FourByFourMenu from './FourByFourMenu'
import SixBySixMenu from './SixBySixMenu'
import EightByThreeMenu from './EightByThreeMenu'

export default {
  Home,
  Menu,
  OverviewMenu,
  SidebarPage,
  SidebarSlideshow,
  Slideshow,
  InteractiveElement,
  FullContentDisplay,
  FourByFourMenu,
  SixBySixMenu,
  EightByThreeMenu
}



// WEBPACK FOOTER //
// ./src/layouts/index.js